import { render, staticRenderFns } from "./BatteryIcon.vue?vue&type=template&id=b29a5afe&scoped=true&"
import script from "./BatteryIcon.vue?vue&type=script&lang=js&"
export * from "./BatteryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29a5afe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VLayout})
